/* eslint-disable camelcase */
import isMSLegacy from "common/utils/is-ms-legacy";
import {
  getStepData,
  LEGACY_getStepData,
  LEGACY_saveStepData,
  saveStepData,
} from "features/budget/wizard/state/wizard.storage";

const STEP = 0;

export async function saveBudgetMeta(budgetMeta) {
  let meta = { ...budgetMeta };

  // Save Sets as arrays
  const newDueDates = budgetMeta?.newDueDatesSet;
  if (newDueDates !== undefined && newDueDates instanceof Set) {
    const newDueDatesSet = [...newDueDates.values()];
    meta = { ...meta, newDueDatesSet };
  }

  const newTemplates = budgetMeta?.newTemplatesSet;
  if (newTemplates !== undefined && newTemplates instanceof Set) {
    const newTemplatesSet = [...newTemplates.values()];
    meta = { ...meta, newTemplatesSet };
  }

  if (isMSLegacy() === true) {
    LEGACY_saveStepData(STEP, meta);
  } else {
    await saveStepData(STEP, meta);
  }
}

export async function getBudgetMeta() {
  let meta;

  if (isMSLegacy() === true) {
    meta = LEGACY_getStepData(STEP);
  } else {
    meta = await getStepData(STEP);
  }

  // Convert arrays back to Sets
  if (meta !== undefined) {
    const newDueDates = meta.newDueDatesSet;
    const newTemplates = meta.newTemplatesSet;
    if (newDueDates !== undefined && Array.isArray(newDueDates)) {
      const newDueDatesSet = new Set(newDueDates);
      meta = {
        ...meta,
        newDueDatesSet,
      };
    }
    if (newTemplates !== undefined && Array.isArray(newTemplates)) {
      const newTemplatesSet = new Set(newTemplates);
      meta = {
        ...meta,
        newTemplatesSet,
      };
    }
  }

  return meta;
}

export async function clearBudgetMeta() {
  await saveBudgetMeta(undefined);
}
